var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000762939 3.26624C0.00225067 2.74292 0.113361 2.22615 0.325293 1.74977C0.547466 1.23455 0.910027 0.795585 1.36968 0.485307C1.82933 0.17503 2.36664 0.00655423 2.91743 0L16.6444 0C17.1951 0.00655423 17.7325 0.17503 18.1921 0.485307C18.6518 0.795585 19.0143 1.23455 19.2365 1.74977C19.5104 2.3426 19.6159 3.00216 19.541 3.6533C19.4661 4.30444 19.2137 4.92097 18.8126 5.43262L11.9492 13.9315C11.6896 14.2648 11.3598 14.5339 10.9844 14.7189C10.609 14.9039 10.1976 15 9.78089 15C9.36414 15 8.95276 14.9039 8.57735 14.7189C8.20195 14.5339 7.87219 14.2648 7.61263 13.9315L0.749163 5.43262C0.263134 4.82 -0.0016861 4.05499 -0.000762939 3.26624Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownMenu);
export default __webpack_public_path__ + "static/media/downMenu.e3c6adace89a66910d14719661c84b5a.svg";
export { ForwardRef as ReactComponent };